import { render, staticRenderFns } from "./ComponentDepositWithdrawal.vue?vue&type=template&id=33ddd8a6"
import script from "./ComponentDepositWithdrawal.vue?vue&type=script&lang=js"
export * from "./ComponentDepositWithdrawal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports